// middleware/errorHandler.js
const errorHandler = store => next => action => {
  if (action.type.endsWith('FAILURE')) {
    // Handle the error globally (e.g., logging or notifications)
    // You could also dispatch a global notification action here
  }
  return next(action);
};

export default errorHandler;
